import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from 'src/app/modules/shared/services/language.service';

@Component({
  standalone: false,
  selector: 'app-confirm-initial-cost-dialog',
  templateUrl: './confirm-initial-cost-dialog.component.html',
  styleUrls: ['./confirm-initial-cost-dialog.component.css']
})
export class ConfirmInitialCostDialogComponent implements OnInit {

  variables: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { amount: number },
    public dialogRef: MatDialogRef<ConfirmInitialCostDialogComponent>,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
